/////////////////////////////////////////////////////////////////////////
// The company and contact details used by the legal pages.            //
//                                                                     //
// They live in one place so that a change of address or support inbox //
// is a single edit rather than a hunt through three long documents.   //
/////////////////////////////////////////////////////////////////////////

import appSettings from '../../config/settings';

export const COMPANY = {
  // ethy is the trading name; the contracting entity is the limited company.
  tradingName: 'ethy',
  legalName: 'Scratch the Surface Ltd',
  jurisdiction: 'England and Wales',
  website: 'https://ethy.co.uk',
  marketplaceUrl: 'https://ethy.co.uk/marketplace',
  supportEmail: 'hello@ethy.co.uk',
  privacyEmail: 'hello@ethy.co.uk',
};

// Where shoppers can read how ethy verifies the brands and products it lists.
// Kept here (rather than only on the product page) because all three legal
// documents, the footer and the topbar point at it.
export const VERIFICATION_URL = 'https://ethy.co.uk/brand-solutions/verify-your-claims';

// Shown as "Last updated" on each document. Update it whenever the wording of a
// document changes materially — shoppers and sellers rely on it to tell whether
// the terms they agreed to are still the terms in force.
export const LAST_UPDATED = '10 September 2026';

// A markdown link to the company's support inbox, used throughout the documents.
export const supportEmailLink = `[${COMPANY.supportEmail}](mailto:${COMPANY.supportEmail})`;

// In-app paths of the three legal documents, so that the documents can link to
// one another from inside their markdown. The marketplace is mounted under a
// path prefix, and PageBuilder's markdown links are only rendered as in-app
// links when the href matches a route, so the prefix has to be included.
//
// NOTE: keep these paths in sync with routeConfiguration.js.
export const LEGAL_PATHS = {
  termsOfService: `${appSettings.marketplacePrefix}/terms-of-service`,
  privacyPolicy: `${appSettings.marketplacePrefix}/privacy-policy`,
  termsAndConditionsOfSale: `${appSettings.marketplacePrefix}/terms-and-conditions-of-sale`,
};
